/**
 * pp-collection-filters-drawer.js
 *
 * Mobile-only behavior for the collection filters panel: turns the static
 * aside into a slide-in drawer from the right. Triggered by the
 * [data-pp-filters-trigger] button. Closes via:
 *   - tap on the X button
 *   - tap on the backdrop
 *   - swipe right-to-left → ojo: drawer entra desde la derecha, así que
 *     el swipe natural para cerrar es de IZQUIERDA a DERECHA (lo arrastras
 *     fuera de la pantalla). Hacemos ese gesto.
 *   - Esc key
 *
 * No-op en desktop — el aside vive inline siempre.
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = '(max-width: 749px)';

  function init() {
    var trigger = document.querySelector('[data-pp-filters-trigger]');
    var drawer = document.querySelector('[data-pp-filters-drawer]');
    var backdrop = document.querySelector('[data-pp-filters-backdrop]');
    var closeBtn = document.querySelector('[data-pp-filters-close]');
    if (!trigger || !drawer || !backdrop) return;

    function isMobile() {
      return window.matchMedia(MOBILE_BREAKPOINT).matches;
    }

    function open() {
      if (!isMobile()) return;
      drawer.classList.add('is-open');
      backdrop.removeAttribute('hidden');
      // forzar reflow para que la transición arranque limpia
      // eslint-disable-next-line no-unused-expressions
      backdrop.offsetWidth;
      backdrop.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('pp-filters-drawer-open');
    }

    function close() {
      // FASE 2: lo que se escogió en el cajón se aplica al cerrarlo (no se
      // pierde). pp-product-card.js marca el form con data-pp-filtros-pendientes.
      var formPend = drawer.querySelector('[data-pp-filters-form][data-pp-filtros-pendientes]');
      if (formPend) { formPend.removeAttribute('data-pp-filtros-pendientes'); formPend.submit(); }
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pp-filters-drawer-open');
      drawer.style.transform = '';
      // Después de la transición ocultar el backdrop del DOM.
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          backdrop.setAttribute('hidden', '');
        }
      }, 260);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    backdrop.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    // Swipe horizontal para cerrar — el drawer entra desde la izquierda,
    // así que arrastrarlo hacia la izquierda (dx negativo) lo saca.
    var startX = null;
    var startY = null;
    var dragging = false;
    var currentDx = 0;

    drawer.addEventListener('touchstart', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      // Si el touch viene de un input o select dentro del form, no arrastramos.
      if (e.target.closest('input, select, textarea, button')) {
        if (!e.target.closest('[data-pp-filters-close]')) return;
      }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
      currentDx = 0;
      drawer.style.transition = 'none';
    }, { passive: true });

    drawer.addEventListener('touchmove', function (e) {
      if (!dragging || startX === null) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      // Si el movimiento es más vertical que horizontal, abortar drag
      // (el user está scrolleando el contenido).
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
        dragging = false;
        drawer.style.transform = '';
        drawer.style.transition = '';
        return;
      }
      if (dx > 0) {
        // intentando arrastrar hacia adentro (derecha); ignorar.
        drawer.style.transform = '';
        return;
      }
      currentDx = dx;
      drawer.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      drawer.style.transition = '';
      if (currentDx < -80) {
        close();
      } else {
        drawer.style.transform = '';
      }
      startX = null;
      startY = null;
      currentDx = 0;
    }
    drawer.addEventListener('touchend', endDrag);
    drawer.addEventListener('touchcancel', endDrag);

    // Si el viewport pasa de mobile a desktop con el drawer abierto, cerrar.
    var mq = window.matchMedia(MOBILE_BREAKPOINT);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (ev) {
        if (!ev.matches && drawer.classList.contains('is-open')) {
          close();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
